__turbopack_context__.v({
  "deliveryNavigation": "DeliveryNavigation-module__8bRLMq__deliveryNavigation",
});
